import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { IGioCongDongHoatDongAddOrEdit } from "../../../models/response/gio-cong-dong/IGioCongDongHoatDongAddOrEdit";
import { IGioCongDongHoatDongVm } from './../../../models/response/gio-cong-dong/IGioCongDongHoatDong';
export enum eGioCongDongHoatDongReducerStatus {
    is_loading_detail = "is_loading_detail",
    is_load_detail_success = "is_load_detail_success",
    is_load_detail_error = "is_load_detail_error",
}

export interface IGioCongDongHoatDongReducer {
    status: ePageBaseStatus | eGioCongDongHoatDongReducerStatus
    gioCongDongHoatDongs: IGioCongDongHoatDongVm[],
    editingData?: IGioCongDongHoatDongAddOrEdit,
    savedId?: number
}